// extracted by mini-css-extract-plugin
export default {"reaction":"Reaction_reaction__ImA4a","reactButton":"Reaction_reactButton__msbKL","active":"Reaction_active__WRBUJ"};